import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import {structureReducer} from "@features/reducers/structure/structure";
import {settingsReducer} from "@features/reducers/settings/settings";
import {administrationReducer} from "@features/reducers/administration/administration";
import {hrReducer} from "@features/reducers/hr/hr";
import {learningReducer} from "@features/reducers/learning/learning";
import {studentsReducer} from "@features/reducers/students/students";
import {coreReducer} from "@features/reducers/core/core";

const rootReducer = combineReducers({
    ...structureReducer,
    ...settingsReducer,
    ...administrationReducer,
    ...hrReducer,
    ...learningReducer,
    ...studentsReducer,
    ...coreReducer,
})

export const store = configureStore({
    reducer: rootReducer,
    devTools: true,

})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useAppDispatch: () => AppDispatch = useDispatch
